import React from 'react';
import { SelectInput } from 'react-admin';

const priorityChoices = [
    { id: 'low', name: 'Low' },
    { id: 'normal', name: 'Normal' },
    { id: 'high', name: 'High' },
    { id: 'urgent', name: 'Urgent' }
];

const PriorityInput = (props) => (
    <SelectInput
        source="priority"
        choices={priorityChoices}
        defaultValue="normal"
        {...props}
    />
);

export default PriorityInput;
